/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PasswordChange from './PasswordChange';
import MapSetting from './MapSetting';
import GroupSetting from './GroupSetting';

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(20),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
});

class MySettingsBody extends React.Component {
  state = {
    expanded: null,
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const {classes} = this.props;
    const {expanded} = this.state;

    return (
      <div className={classes.root}>
        <Accordion expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Změna hesla</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PasswordChange />
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Nastavení mapy</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MapSetting />
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Skupiny</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <GroupSetting />
          </AccordionDetails>
        </Accordion>
      </div>
    );
  }
}

MySettingsBody.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MySettingsBody);
